import { clampRound } from './clamp';

const { abs, floor, round } = Math;

export function clampIndex(index: number, length: number) {
  const count = floor(abs(length)) || 1;
  return clampRound(index, 0, count - 1);
}

export function clampIndexLoop(index: number, length: number) {
  const count = floor(abs(length)) || 1;
  return ((round(index) % count) + count) % count;
}

export function clampPage(page: number, pageCount: number) {
  return clampIndex(page - 1, pageCount) + 1;
}

export function clampPageLoop(page: number, pageCount: number) {
  return clampIndexLoop(page - 1, pageCount) + 1;
}
